import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PerfectScrollbar from "perfect-scrollbar";
import {
  hideMessage,
  isValidCard,
  clearCard,
  clearCardResponse,
} from "../store/cards";
import { getTicketTypes, resetSelectedTickets } from "../store/tickets";
import hideFromRoutes from "../hoc/hideFromRoutes";
import Card from "./Card";
import CardAddedList from "./CardAddedList";

class CardsList extends PureComponent {
  constructor(props) {
    super(props);

    this.containerRef = React.createRef();

    this.state = {
      activeCard: null,
      open: false,
      activeInvalidateCard: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (state.activeCard !== null && props.route !== "/entradas") {
      return {
        activeCard: null,
        open: false,
      };
    }

    return null;
  }

  componentDidMount() {
    if (this.containerRef.current !== null) {
      this.ps = new PerfectScrollbar(this.containerRef.current, {
        suppressScrollX: true,
      });
      setTimeout(() => {
        if (this.ps !== null) this.ps.update();
      }, 1500);
    }

    //if (this.props.folio === null) {
    //  this.props.clearCard();
    //}
  }

  componentWillUnmount() {
    if (this.containerRef.current !== null) {
      this.ps.destroy();
      this.ps = null;
    }
  }

  handleActiveCard = (cardName) => {

    this.setState(() => ({ activeCard: cardName }));
  };

  cancelActiveCard = () => {
    if (this.props.isLoading) {
      this.props.hideMessage();
    }
    this.setState(() => ({ activeCard: null }));
  };

  handleAddCard = (folio, token) => {
    this.props.isValidCard(folio, false, token);
  
  };

  handleRemoveCard = () => {
    this.props.clearCard();
    this.props.getTicketTypes(
      this.props.cinemaVistaId,
      this.props.showtimeVistaId,
      true
    );
    this.props.resetSelectedTickets();
  };

  handleEditCard = () => {
    this.setState({ activeCard: this.props.folio.parent_code });
  };

  render() {
    const { activeCard } = this.state;
    const shouldCardChange = this.props.route === "/entradas";

    if (
      !this.props.folio &&
      (this.props.route === "/butacas" || this.props.route === "/pago")
    ) {
      return null;
    }

    return (
      <div
        className={`cards-list${this.state.open ? " mob-active" : ""}${
          this.state.activeCard !== null && this.props.isMobile
            ? " mob-open"
            : ""
        }`}
      >
        <div className="grabber" onClick={this.props.toggleCards}></div>

        <header className="cards-list__head">
          <p className={`text${activeCard !== null ? " hidden" : ""}`}>
            <span>¿Cuentas con alguna tarjeta o promoción?</span>
          </p>

          <span
            type="button"
            className={`icon-cross icon-cross--circle${
              activeCard !== null ? " hidden" : ""
            }`}
            onClick={this.props.toggleCards}
            aria-label="Cerrar listado tarjeta o promoción"
            style={{cursor: 'pointer'}}
          >
            <svg width="11" height="11" viewBox="0 0 11 11">
              <g fill="#000000" fillRule="nonzero">
                <path d="M.793 2.207A1 1 0 1 1 2.207.793l8.062 8.062a1 1 0 0 1-1.414 1.414L.793 2.207z" />
                <path d="M2.207 10.207A1 1 0 0 1 .793 8.793L8.855.73a1 1 0 1 1 1.414 1.414l-8.062 8.062z" />
              </g>
            </svg>
          </span>
        </header>
        <div
          className={`cards${
            this.state.activeCard !== null || this.props.folio !== null
              ? " cards--auto"
              : ""
          }`}
          ref={this.containerRef}
        >
          {this.props.cardsData.map((card, cardIndex) => {
            return (
              <Card
                hasLoyalty={this.props.hasLoyalty}
                key={`${card.name}-${card.order}`}
                active={activeCard === card.code}
                activeFolio={
                  this.props.folio !== null &&
                  this.props.folio.parent_code === card.code &&
                  card.code !== "otros"
                }
                folio={null}
                folios_is_max={this.props.cardList}
                hide={activeCard !== null && activeCard !== card.code}
                name={card.name}
                code={card.code}
                bins={card.bins}
                cssName={
                  card.name === "Otros" ||
                  card.name === "FICM" ||
                  card.name === "MasterCard" ||
                  card.code === "club-carrefour"
                    ? "otros"
                    : ""
                }
                numInputs={
                  card.name === "Otros" ||
                  card.name === "FICM" ||
                  card.name === "MasterCard" ||
                  card.code === 'club-carrefour'
                    ? 1
                    : 4
                }
                formLabel={
                  card.name === "Otros"
                    ? "FOLIO o CINEPASS"
                    : card.name === "FICM"
                    ? "FOLIO FICM"
                    : card.name === ""
                    ? "FOLIO MASTERCARD"
                    : ""
                }
                buttonImage={card.images.select}
                bgImage={card.images.reference}
                addedImage={card.images.added}
                style={{ animationDelay: `${cardIndex * 0.088 + 0.13}s` }}
                submitButtonText={
                  card.name === "Otros" || card.name === "FICM"
                    ? "folio"
                    : card.name.toLowerCase()
                }
                showForm={this.handleActiveCard}
                onSubmit={this.handleAddCard}
                isLoading={this.props.isLoading}
                hideForm={this.cancelActiveCard}
                removeCard={this.handleRemoveCard}
                response={this.props.response}
                modalOpen={this.props.modalOpen}
                shouldCardChange={shouldCardChange}
                hasCardListBenefits={this.props.cardList !== []}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ cards, ui, globals, showtime }) => ({
  isMobile: ui.isMobile,
  showCardsList: ui.showCardsList,
  isLoading: cards.isLoading,
  response: cards.response,
  folio: cards.folio,
  cardList: cards.cardList,
  cardsData: showtime.benefits,
  cinemaVistaId: globals.cinemaVistaId,
  showtimeVistaId: globals.showtimeVistaId,
  modalOpen: ui.modal !== null && ui.modal.type.indexOf("pin") > -1,
  hasLoyalty: cards.hasLoyalty,
});

export default hideFromRoutes(
  connect(mapStateToProps, {
    isValidCard,
    hideMessage,
    clearCard,
    clearCardResponse,
    getTicketTypes,
    resetSelectedTickets,
  })(CardsList),
  ["/error", "/confirmacion", "/"]
);
